var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.alerts),function(alert){return _c('b-alert',{key:alert.id,attrs:{"dismissible":"","show":5,"variant":alert.type},on:{"dismissed":function($event){return _vm.closeAlert(alert.id)}}},[_vm._v(" "+_vm._s(alert.data)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }